import SmoothScroll from 'smooth-scroll';
import NavButton from "./global/nav-button";
import StageSlider from "./components/stage-slider";
import TeaserSlider from "./components/teaser-slider";
import MapFade from "./components/map-fade";
import ElementFadeIns from "./fade-ins/element-fade-ins";
import ImageFadeIns from "./fade-ins/image-fade-ins";
import FooterFade from "./global/footer-fade";
import Accordion from "./elements/accordion";
import ScrollDirection from "./global/scroll-direction";
import ScrollThreshold from "./global/scroll-threshold";
import Navigation from "./global/navigation";
import QuotesSlider from "./components/quotes-slider";
import TimelineSlider from "./components/timeline-slider";
import BenefitsSlider from "./components/benefits-slider";
import ApplicationFormValidation from "./components/application-form-validation";

document.addEventListener("DOMContentLoaded", () => {
    new Accordion()
    new ApplicationFormValidation()
    new NavButton()
    new MapFade()
    new ElementFadeIns()
    new FooterFade()
    new ImageFadeIns()
    new Navigation()
    new ScrollDirection()
    new ScrollThreshold()
    new SmoothScroll('a[href*="#"]', {
        speed: 800,
        easing: 'easeInOutQuart',
        speedAsDuration: true,
        // offset: 98
    });

    document.querySelectorAll('.js-stage-slider').forEach((el) => {
        new StageSlider(el); // <— wichtig: el übergeben
    });
    document.querySelectorAll(".js-teaser-slider").forEach((el) => {
        new TeaserSlider(el);
    });
    document.querySelectorAll(".js-quotes-slider").forEach((el) => {
        new QuotesSlider(el);
    });
    document.querySelectorAll(".js-timeline-slider").forEach((el) => {
        new TimelineSlider(el);
    });
    document.querySelectorAll(".js-benefits-slider").forEach((el) => {
        new BenefitsSlider(el);
    });

})

